import { useEffect, useRef } from "react";

const COLORS = ["224,170,255", "199,125,255", "248,247,255", "123,44,191", "226,232,240"];

export const StarfieldCanvas = () => {
    const ref = useRef(null);

    useEffect(() => {
        const canvas = ref.current;
        const ctx = canvas.getContext("2d");
        let w = 0;
        let h = 0;
        let raf;

        const resize = () => {
            w = canvas.width = window.innerWidth;
            h = canvas.height = window.innerHeight;
        };
        resize();
        window.addEventListener("resize", resize);

        const stars = Array.from({ length: 240 }, () => ({
            x: Math.random(),
            y: Math.random(),
            r: Math.random() * 1.4 + 0.3,
            p: Math.random() * Math.PI * 2,
            s: 0.4 + Math.random() * 1.6,
            c: COLORS[Math.floor(Math.random() * COLORS.length)],
        }));
        const dust = Array.from({ length: 60 }, () => ({
            x: Math.random(),
            y: Math.random(),
            r: Math.random() * 2 + 0.6,
            vx: (Math.random() - 0.5) * 0.00025,
            vy: (Math.random() - 0.5) * 0.00018,
            c: COLORS[Math.floor(Math.random() * COLORS.length)],
        }));
        const nebulae = Array.from({ length: 5 }, (_, i) => ({
            x: Math.random(),
            y: Math.random(),
            r: 0.28 + Math.random() * 0.3,
            p: Math.random() * Math.PI * 2,
            hue: i % 2 ? "123,44,191" : "90,24,154",
        }));

        const draw = (t) => {
            ctx.clearRect(0, 0, w, h);

            nebulae.forEach((n) => {
                const nx = (n.x + Math.sin(t * 0.00002 + n.p) * 0.08) * w;
                const ny = (n.y + Math.cos(t * 0.000016 + n.p) * 0.06) * h;
                const nr = n.r * Math.max(w, h);
                const g = ctx.createRadialGradient(nx, ny, 0, nx, ny, nr);
                g.addColorStop(0, `rgba(${n.hue},0.15)`);
                g.addColorStop(1, "rgba(6,1,15,0)");
                ctx.fillStyle = g;
                ctx.beginPath();
                ctx.arc(nx, ny, nr, 0, Math.PI * 2);
                ctx.fill();
            });

            dust.forEach((d) => {
                d.x = (d.x + d.vx + 1) % 1;
                d.y = (d.y + d.vy + 1) % 1;
                ctx.fillStyle = `rgba(${d.c},0.35)`;
                ctx.beginPath();
                ctx.arc(d.x * w, d.y * h, d.r, 0, Math.PI * 2);
                ctx.fill();
            });

            stars.forEach((s) => {
                const a = 0.2 + 0.8 * Math.abs(Math.sin(t * 0.001 * s.s + s.p));
                ctx.fillStyle = `rgba(${s.c},${a})`;
                ctx.beginPath();
                ctx.arc(s.x * w, s.y * h, s.r, 0, Math.PI * 2);
                ctx.fill();
            });

            raf = requestAnimationFrame(draw);
        };
        raf = requestAnimationFrame(draw);

        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
        };
    }, []);

    return (
        <canvas
            ref={ref}
            data-testid="starfield-canvas"
            aria-hidden="true"
            className="pointer-events-none fixed inset-0 -z-10"
        />
    );
};
